import { useEffect, useState } from 'react';

const TOKEN_KEY = 'accessToken';
const USER_ID_KEY = 'userId';
const AUTH_EVENT = 'auth:changed';

export const getAccessToken = (): string | null =>
  localStorage.getItem(TOKEN_KEY);

export const getUserId = (): string | null =>
  localStorage.getItem(USER_ID_KEY);

export const isAuthenticated = (): boolean => !!getAccessToken();

export const setAuth = (token: string, userId: string): void => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_ID_KEY, userId);
  window.dispatchEvent(new Event(AUTH_EVENT));
};

export const clearAuth = (): void => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_ID_KEY);
  window.dispatchEvent(new Event(AUTH_EVENT));
};

export const authHeader = (): Record<string, string> => {
  const t = getAccessToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

// Reactive hook — components re-render on login/logout without route change.
// Listens to same-tab custom event + cross-tab storage event.
export const useIsAuthenticated = (): boolean => {
  const [authed, setAuthed] = useState<boolean>(isAuthenticated());
  useEffect(() => {
    const sync = () => setAuthed(isAuthenticated());
    window.addEventListener(AUTH_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(AUTH_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);
  return authed;
};
